<template>
  <Preloader></Preloader>
  <Navbar></Navbar>
  <Sidebar></Sidebar>

  <div
    :class="{
      'extended-wrapper': !isAuthenticated,
      'content-wrapper': isAuthenticated,
    }"
  >
    <ContentHeader></ContentHeader>

    <section :class="{ content: isAuthenticated }">
      <div :class="{ 'container-fluid': isAuthenticated }">
        <div id="overlay" v-if="isLoading">
          <div class="w-100 d-flex justify-content-center align-items-center">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
        </div>
        <router-view />
      </div>
    </section>
  </div>
  <Footer></Footer>
</template>

<script>
import Preloader from './dashboard/Preloader.vue';
import ContentHeader from './dashboard/ContentHeader.vue';
import Navbar from './dashboard/Navbar.vue';
import Sidebar from './dashboard/Sidebar.vue';
import Footer from './dashboard/Footer.vue';

export default {
  name: 'App',
  components: {
    Preloader,
    ContentHeader,
    Navbar,
    Sidebar,
    Footer,
  },
  data() {
    return {
      timer: null,
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters['users/isAuthenticated'];
    },
    isLoading() {
      return this.$store.getters['options/isLoading'];
    },
    lastStartTime() {
      return this.$store.getters['timeTracker/getLastStartTime'];
    },
  },
  methods: {
    checkToken() {
      this.$store
        .dispatch('users/checkToken')
        .then(() => {
          this.getInfo();
        })
        .catch(() => {
          this.$router.push('/login');
        });
    },
    async getInfo() {
      await this.$store.dispatch('users/retrieveUserData').then(() => {});
    },
    addTraillingZero(inputNumber) {
      return inputNumber < 10 && inputNumber >= 0
        ? `0${inputNumber}`
        : inputNumber.toString();
    },
    startTimer() {
      this.timer = setInterval(() => {
        if (this.lastStartTime !== null) {
          const tempCurrentTime = new Date() - this.lastStartTime;
          const seconds = Math.floor(tempCurrentTime / 1000);
          const days = Math.floor(seconds / (60 * 60 * 24));
          const hours = Math.floor((seconds % (60 * 60 * 24)) / (60 * 60));
          const minutes = Math.floor((seconds % (60 * 60)) / 60);
          const remainingSeconds = seconds % 60;

          const duration = `${days > 0 ? `${days}d ` : ''}${
            hours > 0 ? `${hours}h ` : ''
          }${minutes > 0 ? `${minutes}m ` : ''}${
            remainingSeconds > 0 ? `${remainingSeconds}s` : ''
          }`;

          const currentTime = `${this.addTraillingZero(
            hours,
          )}${this.addTraillingZero(minutes)}${this.addTraillingZero(remainingSeconds)}`;
          this.$store.dispatch('timeTracker/updateStopwatch', currentTime);
          document.title = `MySpace ( ${duration} )`;
        } else {
          document.title = 'MySpace';
          this.$store.dispatch('timeTracker/updateStopwatch', '000000');
        }
      }, 1000);
    },
  },
  created() {
    console.log('env', process.env.VUE_APP_ENV);
  },
  mounted() {
    this.checkToken();
    this.$store.dispatch('timeTracker/getLastTimeEntry');
    this.startTimer();
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,400i,700&display=fallback");

@import url("./assets/css/style.css");

.extended-wrapper {
  margin: 0 auto !important;
}

.container-fluid {
  position: relative;
}
#overlay {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: calc(100vh - 130px);
  background-color: rgba(208, 214, 226, 0.5);
  z-index: 2;
  cursor: pointer;
}
</style>
